import { createContextualCan } from '@casl/react';
import { AuthorizationContext, TAppAbility } from 'auth/authorization';

export const Can = createContextualCan<TAppAbility>(AuthorizationContext.Consumer);
